var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "user form-horizontal",
                attrs: { role: "form" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "fieldset",
                  [
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_URL_PARAMETER"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("INPUT_LABEL_URL_PARAMETER_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "incomingQueryStringName",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.urlParameter
                                                            .incomingQueryStringName,
                                                        expression:
                                                          "urlParameter.incomingQueryStringName"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name:
                                                        "incomingQueryStringName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.urlParameter
                                                          .incomingQueryStringName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.urlParameter,
                                                          "incomingQueryStringName",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_REPORTING_MENU_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t(
                          "INPUT_LABEL_REPORTING_MENU_NAME_TT"
                        )
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "mapToTagType",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.urlParameter
                                                            .mapToTagType,
                                                        expression:
                                                          "urlParameter.mapToTagType"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      placeholder: _vm.$t(
                                                        "USER_TEXT"
                                                      ),
                                                      type: "text",
                                                      name: "mapToTagType",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.urlParameter
                                                          .mapToTagType
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.urlParameter,
                                                          "mapToTagType",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("Field", {
                      attrs: {
                        label: _vm.$t("INPUT_LABEL_REPORT_NAME"),
                        "has-tooltip": true,
                        "tooltip-text": _vm.$t("INPUT_LABEL_REPORT_NAME_TT")
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "element",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "mapToTagName",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("div", { class: classes }, [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "col-sm-4 col-md-3"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.urlParameter
                                                            .mapToTagName,
                                                        expression:
                                                          "urlParameter.mapToTagName"
                                                      }
                                                    ],
                                                    staticClass: "form-control",
                                                    attrs: {
                                                      type: "text",
                                                      name: "mapToTagName",
                                                      autocomplete: "off"
                                                    },
                                                    domProps: {
                                                      value:
                                                        _vm.urlParameter
                                                          .mapToTagName
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        )
                                                          return
                                                        _vm.$set(
                                                          _vm.urlParameter,
                                                          "mapToTagName",
                                                          $event.target.value
                                                        )
                                                      }
                                                    }
                                                  })
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("label", {
                                                directives: [
                                                  {
                                                    name: "t",
                                                    rawName: "v-t",
                                                    value: "REQUIRED",
                                                    expression: "'REQUIRED'"
                                                  }
                                                ],
                                                staticClass:
                                                  "col-sm-3 col-md-3 col-xs-2 form-group__label-required"
                                              })
                                            ])
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-sm-8 col-md-8 col-md-offset-3 col-sm-offset-3"
                        },
                        [
                          _c(
                            "PrimaryButton",
                            {
                              attrs: {
                                size: "sm",
                                "show-loader-on-form": _vm.showLoader
                              }
                            },
                            [
                              _c("span", {
                                directives: [
                                  {
                                    name: "t",
                                    rawName: "v-t",
                                    value: _vm.isNewUrlParameter
                                      ? "CREATE"
                                      : "UPDATE",
                                    expression:
                                      "isNewUrlParameter ? 'CREATE' : 'UPDATE'"
                                  }
                                ]
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("button", {
                            directives: [
                              {
                                name: "t",
                                rawName: "v-t",
                                value: "CANCEL",
                                expression: "'CANCEL'"
                              }
                            ],
                            staticClass: "btn btn-sm btn-danger m-l-15",
                            on: { click: _vm.cancel }
                          })
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }